import axios from 'api';

const url = '/api/orders';

const OrdersApi = {
  getClientOrders: (id: string, params: Record<string, any>) => axios.get(`${url}/${id}`, { params }),
};

export default OrdersApi;
